export default __webpack_public_path__ + "static/media/return.52c1fa21.svg";